<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-xl-9 col-lg-8">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>{{ $t('home.header.HelpCenter') }}</p><img src="/img/up-arrow.7f2fb856.svg" alt="logo"
                                class="right-arrow"><a href="#">{{ $t('helpCenter.introduction.creatingPortals.Configure')
                                }} </a>
                        </div>
                        <div class="according-menu">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne"><button class="accordion-button"
                                            type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                            aria-expanded="true" aria-controls="collapseOne">
                                            <p>{{ $t('doc.product.OnThisPage') }}</p>
                                            <span class="down_up_icon"><img src="/img/up_arrow_side.7f2fb856.svg"
                                                    alt=""></span>
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div class="tableOfContents-list">
                                                <ul id="side_section_info">
                                                    <ul>
                                                        <li
                                                            class="{ 'active_menu_item': rightPanelMenuItem === '#how-to-get-ssl-certificate-for-your-custom-domain' }">
                                                            <a
                                                                @click="scrollTo('#how-to-get-ssl-certificate-for-your-custom-domain')">

                                                                {{ $t('helpCenter.configSSL.certificate') }}
                                                            </a>
                                                            <ul>
                                                                <li
                                                                    class="{ 'active_menu_item': rightPanelMenuItem === '#create-a-portal-in-chatwoots-dashboard' }">
                                                                    <a
                                                                        @click="scrollTo('#create-a-portal-in-chatwoots-dashboard')">
                                                                        {{ $t('helpCenter.configSSL.Portal') }}</a>
                                                                </li>
                                                                <li
                                                                    class="{ 'active_menu_item': rightPanelMenuItem === '#point-your-custom-domain-to-chatwoothelp' }">
                                                                    <a
                                                                        @click="scrollTo('#point-your-custom-domain-to-chatwoothelp')">{{
                                                                            $t('helpCenter.configSSL.custom') }}</a>
                                                                </li>
                                                                <li
                                                                    class="{ 'active_menu_item': rightPanelMenuItem === '#providing-ssl' }">
                                                                    <a @click="scrollTo('#providing-ssl')">{{
                                                                        $t('helpCenter.configSSL.ProvidingSSL') }}</a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="Introduction-details text-align-left">
                            <h1>{{ $t('helpCenter.configSSL.configSSConfigure') }}</h1>

                            <p>{{ $t('helpCenter.configSSL.articles') }}</p>
                        </div>

                        <div class="channels-info">
                            <div class="channels-title code-info">

                                <h2 class="anchorarticlenew" id="how-to-get-ssl-certificate-for-your-custom-domain">
                                    {{ $t('helpCenter.configSSL.certificate') }} <a class="hash-link"
                                        href="#how-to-get-ssl-certificate-for-your-custom-domain"
                                        title="Direct link to heading">&ZeroWidthSpace;</a></h2>
                                <h3 class="anchorarticlenew" id="create-a-portal-in-chatwoots-dashboard">{{
                                    $t('helpCenter.configSSL.Portal') }}<a class="hash-link"
                                        href="#create-a-portal-in-chatwoots-dashboard"
                                        title="Direct link to heading">&ZeroWidthSpace;</a></h3>
                                <p> {{ $t('helpCenter.configSSL.documentation') }}</p>
                                <ol class="channels-menu-ol">
                                    <li>{{
                                        $t('helpCenter.configSSL.Navigate') }}</li>
                                    <li>{{ $t('helpCenter.configSSL.Click') }}</li>
                                    <li>{{ $t('helpCenter.configSSL.basic') }}</li>
                                </ol>
                                <ul class="channels-menu-ul">
                                    <li>{{ $t('helpCenter.configSSL.domain') }}
                                    </li>
                                    <li>{{ $t('helpCenter.configSSL.heading') }}</li>
                                    <li>{{ $t('helpCenter.configSSL.auto-generated') }}</li>
                                </ul>
                                <ol class="channels-menu-ol" start="4">
                                    <li>
                                        {{ $t('helpCenter.configSSL.customization') }}
                                    </li>
                                    <li>{{ $t('helpCenter.configSSL.settings') }}</li>
                                </ol>
                                <p><img loading="lazy" alt="interactive_messages"
                                        src="../../../../../assets/images/portal.gif" class="max-img"></p>
                                <p>{{ $t('helpCenter.configSSL.completed') }}
                                </p>
                                <h3 class="anchorarticlenew" id="point-your-custom-domain-to-chatwoothelp">{{
                                    $t('helpCenter.configSSL.domaintobcoor') }}
                                    <a class="hash-link" href="#point-your-custom-domain-to-chatwoothelp"
                                        title="Direct link to heading">&ZeroWidthSpace;</a>
                                </h3>
                                <ol class="channels-menu-ol">
                                    <li>
                                        <p>{{
                                            $t('helpCenter.configSSL.nameserver') }}</p>
                                        <ul class="">
                                            <li style="list-style:circle;">{{ $t('helpCenter.configSSL.docs') }}</li>
                                            <li style="list-style:circle;">{{ $t('helpCenter.configSSL.Cloudflare') }}</li>
                                        </ul>
                                        <p><img alt="cloudfare" src="../../../../../assets/images/cname-cloudfare-1.webp"
                                                class="max-img"></p>
                                        <ul class="">
                                            <li style="list-style:circle;">{{ $t('helpCenter.configSSL.please') }}</li>
                                        </ul>
                                        <p><img alt="aws" src="../../../../../assets/images/cname-aws.webp" class="max-img">
                                        </p>
                                        <ul class="">
                                            <li style="list-style:circle;">{{ $t('helpCenter.configSSL.different') }}
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <p>{{ $t('helpCenter.configSSL.ensure') }}</p>
                                    </li>
                                </ol>
                                <h3 class="anchorarticlenew" id="providing-ssl">{{
                                    $t('helpCenter.configSSL.ProvidingSSL') }}<a class="hash-link" href="#providing-ssl"
                                        title="Direct link to heading">&ZeroWidthSpace;</a></h3>
                                <ol>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.process') }}</li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.support') }}</li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.email') }}</li>
                                </ol>
                                <h4 class="anchorarticle"
                                    id="note-this-step-will-take-12-working-days-from-the-chatwoot-team-for-the-setup">
                                  {{ $t('helpCenter.configSSL.bcoor') }}  <a class="hash-link"
                                        href="#note-this-step-will-take-12-working-days-from-the-chatwoot-team-for-the-setup"
                                        title="Direct link to heading">&ZeroWidthSpace;</a></h4>
                                <p>{{ $t('helpCenter.configSSL.Voila!') }}</p>
                                <p>{{ $t('helpCenter.configSSL.yourdomain') }}</p>
                                <h3 class="anchorarticlenew" id="how-does-this-work">{{ $t('helpCenter.configSSL.How') }}<a class="hash-link" href="#how-does-this-work"
                                        title="Direct link to heading">&ZeroWidthSpace;</a></h3>
                                <p>{{ $t('helpCenter.configSSL.engineering') }}
                                </p>
                                <ol>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.through') }}</li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.engineering') }}
                                    </li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.validate') }}
                                    </li>
                                </ol>
                                <ul class="">
                                    <li style="list-style:disc">
                                        <p>
                                            {{ $t('helpCenter.configSSL.Heroku') }}
                                        </p>
                                    </li>
                                    <li style="list-style:disc">
                                        <p> {{ $t('helpCenter.configSSL.dashboard') }}</p>
                                    </li>
                                    <li style="list-style:disc">
                                        <p>{{ $t('helpCenter.configSSL.serve') }}
                                        </p>
                                        <p><img alt="heroku_dns" src="../../../../../assets/images/add-dns.png"
                                                class="max-img"></p>
                                    </li>
                                    <li style="list-style:disc">
                                        <p>{{ $t('helpCenter.configSSL.After') }}</p>
                                        <p><img alt="heroku" src="../../../../../assets/images/heroku-dns.png"
                                                class="max-img"></p>
                                    </li>
                                </ul>
                                <ol start="5">
                                    <li>
                                        <p>{{ $t('helpCenter.configSSL.until') }}</p>
                                    </li>
                                    <li>
                                        <p>{{ $t('helpCenter.configSSL.certify') }}</p>
                                        <ul class="">
                                            <li style="list-style:circle;">
                                                <p>{{ $t('helpCenter.configSSL.Cloudflaredashboard') }}</p>
                                            </li>
                                            <li style="list-style:circle;">
                                                <p>{{ $t('helpCenter.configSSL.hostname') }}
                                                    <img alt="dns" src="../../../../../assets/images/ssl-dns.webp"
                                                        class="max-img">
                                                </p>
                                            </li>
                                            <li style="list-style:circle;">
                                                <p>{{ $t('helpCenter.configSSL.record') }}</p>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <p>{{ $t('helpCenter.configSSL.reflects') }}
                                        </p>
                                    </li>
                                    <li>
                                        <p>{{ $t('helpCenter.configSSL.ACM') }}
                                        </p>
                                    </li>
                                </ol>
                                <p>{{ $t('helpCenter.configSSL.functionality') }}</p>
                                <ol>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.docsnameserver') }}</li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.help') }}
                                    </li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.configSSLsettings') }}</li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.configSSLconfigportal') }}</li>
                                    <li style="list-style:auto;">{{ $t('helpCenter.configSSL.Redirects') }}
                                    </li>
                                </ol>
                                <ul class="">
                                    <li><img alt="yourdomain" src="../../../../../assets/images/portal-your-domain.png"
                                            class="max-img"></li>
                                </ul>
                                <p>{{ $t('helpCenter.configSSL.Yaay!!') }}</p>
                                <p>{{ $t('helpCenter.configSSL.productdocumentation') }}
                                </p>

                            </div>
                        </div>
                        <div class="edit-update-detail">
                            <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                    aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('Advance.DashboardApps.editPage') }}</a>
                            </div> -->
                            <p>{{ $t('doc.twitter.lastUpdatedOn') }} <span class="dark">{{ $t('helpCenter.introduction.creatingPortals.Edit421') }}</span>{{ $t('doc.product.By') }} <span class="dark">{{ $t('doc.product.Author') }}</span>
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p class="preview">{{ $t('Channels.ApiChannel.sendMessage.previous') }}</p>

                                    <router-link to="/docs/product/features/campaigns/ongoing" class="introduction-account">
                                        <span>«</span> {{ $t('Channels.ApiChannel.sendMessage.createChannelName') }}
                                    </router-link>


                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p>{{ $t('doc.product.Next') }}</p>


                                    <router-link to="/docs/product/others/help-center/configure-ssl-for-help-center">
                                         {{ $t('doc.product.CreateAccount') }}<span>»</span>
                                    </router-link>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4">
                    <section class="tableOfContents">
                        <div class="tableOfContents-list">
                            <ul id="side_section_info">

                                <ul>
                                    <li :class="{ 'active_menu_item': rightPanelMenuItem === '#how-to-get-ssl-certificate-for-your-custom-domain-link' }">
                                        <a id="#how-to-get-ssl-certificate-for-your-custom-domain-link" @click="scrollTo('#how-to-get-ssl-certificate-for-your-custom-domain')">
                                            {{ $t('helpCenter.configSSL.customcertificate') }}</a>
                                        <ul>
                                            <li :class="{ 'active_menu_item': rightPanelMenuItem === '#create-a-portal-in-chatwoots-dashboard-link' }">
                                                <a id="#create-a-portal-in-chatwoots-dashboard-link" @click="scrollTo('#create-a-portal-in-chatwoots-dashboard')">
                                                    {{ $t('helpCenter.configSSL.Portal') }}</a>
                                            </li>

                                            <li :class="{ 'active_menu_item': rightPanelMenuItem === '#point-your-custom-domain-to-chatwoothelp-link' }">
                                                <a id="#point-your-custom-domain-to-chatwoothelp-link" @click="scrollTo('#point-your-custom-domain-to-chatwoothelp')">
                                                    {{ $t('helpCenter.configSSL.custom') }}</a>
                                            </li>

                                            <li :class="{ 'active_menu_item': rightPanelMenuItem === '#providing-ssl-link' }">
                                                <a id="#providing-ssl-link" @click="scrollTo('#providing-ssl')">
                                                    {{ $t('helpCenter.configSSL.ProvidingSSL') }}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>

                            </ul>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import SideBar from "@/components/SideBar.vue";
import MainContent from "@/components/MainContent.vue";

export default {
    name: 'dashboard-apps',
    data() {
        return {
            isToggle: false,
            activeMenuItem: null,
            rightPanelMenuItem: null
        }
    },
    components: {
        Header,
        Footer,
        SideBar,
        MainContent
    },
    mounted() {
        window.addEventListener('scroll', this.setActiveMenuItem);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.setActiveMenuItem);
    },
    methods: {
        scrollTo(selector) {
            const element = document.querySelector(selector);
            if (element) {
                const offset = 106;
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
                this.rightPanelMenuItem = `${selector}-link`
            }
        },
        setActiveMenuItem() {
            const scrollPosition = window.scrollY;
            const menuItems = document.querySelectorAll('#side_section_info li');
            this.activeMenuItem = null
            for (let i = menuItems.length - 1; i >= 0; i--) {
                const menuItem = menuItems[i];
                // console.log(menuItem)
                const target = document.querySelector(menuItem.querySelector('a').getAttribute('id')?.replace(/-link(?=[^-]*$)/, ""));
                if ((target?.offsetTop - 200) <= scrollPosition) {
                    let tempEle
                    if (menuItem) {
                        tempEle = menuItem?.getAttribute('id')
                        let targetID = target?.getAttribute('id')
                        this.rightPanelMenuItem = `#${targetID}-link`
                        // menuItem?.classList.add("active_menu_item");
                    }
                    this.activeMenuItem = tempEle
                    return;
                }
            }
        },
        handleToggle() {
            this.isToggle = !this.isToggle
        }
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}</style>
